var React = require('react');

function GreyCheckmark (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"#E8EFFF","fillOpacity":"0.15","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"23","height":"23","rx":"11.5","stroke":"#E8EFFF","strokeOpacity":"0.3","key":1}),React.createElement("path",{"d":"M16.3 8.3L10 14.6L7.7 12.3C7.3 11.9 6.7 11.9 6.3 12.3C5.9 12.7 5.9 13.3 6.3 13.7L9.3 16.7C9.5 16.9 9.7 17 10 17C10.3 17 10.5 16.9 10.7 16.7L17.7 9.7C18.1 9.3 18.1 8.7 17.7 8.3C17.3 7.9 16.7 7.9 16.3 8.3Z","fill":"#E8EFFF","key":2})]);
}

GreyCheckmark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = GreyCheckmark;

GreyCheckmark.default = GreyCheckmark;
